export const TOGGLE_PLATFORM = 'TOGGLE_PLATFORM'
export const SET_RESULTS = 'SET_RESULTS'
export const SET_QUERY = 'SET_QUERY'
export const SET_SUBMITTED_QUERY = 'SET_SUBMITTED_QUERY'
export const TOGGLE_SUBMITTED = 'TOGGLE_SUBMITTED'
export const TOGGLE_CLEARED = 'TOGGLE_CLEARED'
export const TOGGLE_TOGGLED = 'TOGGLE_TOGGLED'
